<template>
  <li class="top-item">
    <span class="ranking">{{ index + 1 }} </span>
    <div class="image">
      <div class="image-wrap">
        <img :src="imageUrl" @error="imageLoadingError(imageUrl)" />
      </div>
    </div>
    <div class="description">
      <p class="name">
        {{ item.name }}
      </p>
      <p class="id-and-count">
        <i class="icon-external-id" aria-hidden="true" />
        <span>{{ item.external_id }}</span>
        <i class="icon-details" aria-hidden="true" />
        <span>{{ item.count }}</span>
      </p>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imageUrl: `https://res.cloudinary.com/virtusize/image/upload/c_thumb,h_54,w_38/${this.item.cloudinary_public_id}.jpg`,
    };
  },
  methods: {
    imageLoadingError() {
      this.imageUrl = require("@/assets/images/no_image.png");
    },
  },
};
</script>

<style scoped lang="scss">
.top-item {
  display: flex;
  align-items: center;
  height: 62px;
  padding: 4px;

  .ranking {
    width: 35px;
    font-size: 13px;
    text-align: center;
  }

  .image {
    display: table;
    width: 38px;
    height: 54px;
    margin-right: 10px;

    .image-wrap {
      display: table-cell;
      vertical-align: middle;
    }
  }

  .description {
    .name {
      overflow: hidden;
      font-size: 12px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .id-and-count {
      margin-top: 5px;
      color: $gray-600;
      font-size: 9px;
      font-family: "Roboto", sans-serif;

      i {
        margin-right: 5px;
      }

      .icon-details {
        margin-left: 10px;
      }
    }

    width: 80%;
  }
}
</style>
